import { createFileRoute } from "@tanstack/react-router";
import ContactPage from "@/pages/ContactPage";
import { buildHead, SITE_URL } from "@/lib/seo-head";

export const Route = createFileRoute("/contact")({
  head: () =>
    buildHead({
      title: "Contact Abacus | Interior Design & Fit-Out in Bahrain",
      description:
        "Contact Abacus in Bahrain for interior design, fit-out, joinery, MEP and lighting. Request a free quote for your commercial or residential project.",
      path: "/contact",
      schemaJson: {
        "@context": "https://schema.org",
        "@type": "ContactPage",
        name: "Contact Abacus Design Solutions",
        url: `${SITE_URL}/contact`,
      },
    }),
  component: ContactPage,
});
